import { Alert, Modal } from "antd"
import { useState } from "react"
import { TenantMerchantStatusData } from "../../../domain/invoicing/rainforest"
import { useUpdateNextDayAchMutation } from "../../../domain/invoicing/rainforestQueries"
import { isNextDayAchLocked, isNextDayAchOn, nextDayAchPricingText, shouldShowNextDayAchSettings } from "./nextDayAchSettingsModel"
import SwitchWithDescription from "../../common/SwitchWithDescription"
import VSpace from "../../common/VSpace"
import SettingsTitledCard from "../SettingsTitledCard"

type Props = {
  merchantStatusData: TenantMerchantStatusData | undefined
}

const NextDayAchSettingsCard = ({ merchantStatusData }: Props) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const updateMutation = useUpdateNextDayAchMutation(() => setIsConfirmOpen(false))

  if (!shouldShowNextDayAchSettings(merchantStatusData)) {
    return null
  }

  const isOn = isNextDayAchOn(merchantStatusData)
  const isLocked = isNextDayAchLocked(merchantStatusData)
  const pricingText = nextDayAchPricingText(merchantStatusData.acceleratedAchRate)

  const handleToggle = () => {
    if (isOn) {
      updateMutation.mutate(false)
    } else {
      setIsConfirmOpen(true)
    }
  }

  return <SettingsTitledCard
    title="Next-Day ACH Payments"
    description="Get ACH payments from your customers deposited the next business day."
  >
    <VSpace>
      <SwitchWithDescription
        checked={isOn}
        disabled={isLocked}
        label="Enable Next-Day ACH Payments"
        description={`ACH payments deposit to your bank account the next business day.${pricingText ? ` ${pricingText}` : ''}`}
        onClick={handleToggle}
      />
      {isLocked && <Alert
        type="warning"
        showIcon
        message="Next-Day ACH Payments has been disabled by our payment processor."
        description={<>It can't be re-enabled from your settings. Please <a href="mailto:support@synkedup.com">contact support</a> if you have questions or want to turn it back on.</>}
      />}
    </VSpace>
    <Modal
      open={isConfirmOpen}
      title="Enable Next-Day ACH Payments?"
      okText="Enable"
      onOk={() => updateMutation.mutate(true)}
      confirmLoading={updateMutation.isLoading}
      onCancel={() => setIsConfirmOpen(false)}
    >
      <p>ACH payments from your customers will be deposited to your bank account the next business day.</p>
      {pricingText && <p>{pricingText}</p>}
    </Modal>
  </SettingsTitledCard>
}

export default NextDayAchSettingsCard
